import React from 'react'
import { connect } from 'react-redux'
import { Button, Image } from  'semantic-ui-react'
import { reduxForm, Field } from 'redux-form'
import { useMsal } from '@azure/msal-react'
import { loginRequest } from 'variables/authConfig'
import ezlogo from 'assets/images/ez_logo.jpg'
import { login } from 'ducks/authen'
import { getActiveAnnouncements } from 'ducks/system'
import { LoginContainer, BG, SubCont } from './styled'
import { StdForm, Loading } from 'components'
import { validation, validateCase as vCase } from 'core/validate'
// import FieldInput, { InputType as type } from 'components/SemanticForm'
import Moment from 'react-moment'


const Login = (props) => {
  const { listActiveAnnouncements } = props
  const { instance } = useMsal()

  React.useEffect(() => {
    if (listActiveAnnouncements.loading === false) {
      props.getActiveAnnouncements()
    }
  }, [])

  const onLoginSubmit = (values) => {
    props.login({ ...values, username: values.email }, props.history)
  }

  const maintenanceDescription = localStorage.getItem('maintenanceDescription')
  const maintenanceStartTime = localStorage.getItem('maintenanceStartTime')
  const maintenanceEndTime = localStorage.getItem('maintenanceEndTime')

  const isMaintenanceTime = () => {
    const checkDataIsNotEmpty = (data) => {
      return (data !== undefined && data !== null && data !== '')
    }

    return checkDataIsNotEmpty(maintenanceStartTime) &&
           checkDataIsNotEmpty(maintenanceEndTime)
  }

  const announcement = () => {
    const listAnnouncement = listActiveAnnouncements.data.filter(a => a.buyer === true) || []

    if (listAnnouncement.length > 0) {
      return listAnnouncement[0].message || null
    }
    return null
  }

  const renderAnnouncementPanel = () => {
    return (
      <div className='maintenanceContainer'>
        <div className='subContent'>
          <div className='textRow'>
            {
              announcement() || 'ขออภัยค่ะ ขณะนี้ระบบ EzProcure อยู่ระหว่างการปิดปรับปรุง'
            }
          </div>
        </div>
      </div>
    )
  }

  const renderMaintenancePanel = () => {
    return (
      <div className='maintenanceContainer'>
        <div className='subContent'>
          <div className='textRow'>
            {
              maintenanceDescription || 'ขออภัยค่ะ ขณะนี้ระบบ EzProcure อยู่ระหว่างการปิดปรับปรุง'
            }
          </div>
          <div className='textRow'>
            ตั้งแต่
            <Moment format="DD MMM YYYY HH:mm">{maintenanceStartTime}</Moment>
            ถึง
            <Moment format="DD MMM YYYY HH:mm">{maintenanceEndTime}</Moment>
          </div>
        </div>
      </div>
    )
  }

  const onClickLoginWithMicrosoft = (loginType) => {
    if (loginType === 'popup') {
      instance.loginPopup(loginRequest)
      .then((result) => {
        // r.log({ loginResult: result })
      })
      .catch((e) => {
        console.log(e)
        // r.log({loginError: e})
      })
    } else if (loginType === 'redirect') {
      instance.loginRedirect(loginRequest)
      .then((result) => {
        // r.log({ loginResult: result })
      })
      .catch((e) => {
        console.log(e)
        // r.log({loginError: e})
      })
    }
  }

  return (
    <LoginContainer>
      <BG/>
      {
        announcement() ? renderAnnouncementPanel() : null
      }
      {
        isMaintenanceTime() ? 
          renderMaintenancePanel() :
          <SubCont>
            <Image src={ezlogo} size='tiny' bordered rounded/>
            <div style={{height:'1rem'}}/>
            <StdForm 
              fitContent={true} 
              title='EzProcure System' 
              style={{ width: '100%' }} 
              showHeader={false}>
              {/* <form onSubmit={props.handleSubmit((values) => onLoginSubmit(values))}> */}
                <div>
                  {/* <Field label='Username or Email' name='email' component={FieldInput} />
                  <Field label='Password' name='password' type={type.password} component={FieldInput} />
                  <div className='rememberContent'>
                    <Field name='remember' label='Remember me' type={type.checkbox} component={FieldInput} />
                  </div>
                  <div className='contBtn'>
                    <Button type='submit' color='green' content='Login' />
                  </div> */}
                  <div className='contBtn' style={{ marginTop: '5px' }}>
                    {/* <Button 
                      type='button' 
                      color='facebook' 
                      content='Login with Microsoft Account' 
                      onClick={() => onClickLoginWithMicrosoft('popup')}
                    /> */}
                    <Button 
                      type='button' 
                      content='Login' 
                      onClick={() => onClickLoginWithMicrosoft('redirect')}
                    />
                  </div>
                </div>
              {/* </form> */}
            </StdForm>
          </SubCont>
      }
      <Loading/>
    </LoginContainer>
  )
}

const validate = values => {
  let errors = {}
  errors = validation(values, 'email', [vCase.require], errors)
  errors = validation(values, 'password', [vCase.require], errors)

  return errors
}

const mapStateToProps = (state) => ({
  initialValues: {
    email: localStorage.getItem('username'),
    remember: 'true'
  },
  listActiveAnnouncements: state.system.listActiveAnnouncements,
})

const mapDispatchToProps = {
  login,
  getActiveAnnouncements
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formLogin',
  validate: validate
})(Login))
